import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";


const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ComplaintManage/Update?userId=" +
      userData.userId(),
    params
  );
};

const updateComment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ComplaintManage/UpdateComment?userId=" +
      userData.userId(),
    params
  );
}

const deleteItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ComplaintManage/Delete?userId=" +
      userData.userId(),
    params
  );
};

export {  
  updateItem,
  updateComment,
  deleteItem,
};
